import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import PannelBody from "../../../fragments/PannelBody"
import InputBox from "../../../common/interactive/InputBox"
import Button from "../../../common/Button"
import { caseQuickUpdate, insuranceCarrierNursenCreate, insuranceCarrierNurseUpdate, selectInsurance } from "../../../../lib/fetchApi"
import { buildEntityFormContact } from "../../../../lib/countyResolution"
import { countiesOptions } from "../../../../lib/systemData"
import { useContactCountyConfirmation } from "../../../patient/page/countyMismatchConfirm"
import { notificationActions } from "../../../../store/notifications"
import { caseActions } from "../../../../store/case"
import PannelFooter from "../../../fragments/PannelFooter"
import ContactInformation from "./Parts/ContactInformation"

import classes from './Create.module.css'
import { isCompletePhone, isEmail } from "../../../../lib/validation"

const GeneralCreateNurseForm = ({closeModal, itemData, edit, folder, apiCase, fieldsData}) => {

    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)
    const { confirmCountyOnSave, modal: countyMismatchModal } = useContactCountyConfirmation()

    const formSubmitHandler = async (event) => {
        event.preventDefault()
        setIsLoading(true)

        try {
            const fd = new FormData(event.target)

            const formData = Object.fromEntries(fd.entries())

            let errors = []
                                            
            if (formData && formData.email && !isEmail(formData.email)) {
                errors.push('Please check Email Field')
            } 

            if (formData && formData.phone && !isCompletePhone(formData.phone)) {
                errors.push('Please check Phone Field')
            }

            if (formData && formData.cell_phone && !isCompletePhone(formData.cell_phone)) {
                errors.push('Please check Cell Phone Field')
            }

            if (formData && formData.fax && !isCompletePhone(formData.fax)) {
                errors.push('Please check Fax Field')
            }

            if (errors && !errors.length) {
                const originalContact = edit ? itemData?.[fieldsData.fieldobj]?.contact_information : null
                const formContact = buildEntityFormContact(formData)
                const countyResult = await confirmCountyOnSave({
                    token: userToken,
                    originalContact,
                    formContact,
                    selectedCountyId: formData.county,
                    countiesOptions,
                })

                if (countyResult?.error) {
                    dispatch(notificationActions.setError(countyResult.error))
                    return
                }

                if (countyResult.cancelled) {
                    return
                }

                const body = {
                    first_name: formData.adjuster_first_name,
                    last_name: formData.adjuster_last_name,
                    insurance_carrier_id: itemData.insurance_carrier_id,
                    contact_information: {
                        email: formData.email,
                        phone: formData.phone,
                        cell_phone: formData.cell_phone,
                        phone_2: null,
                        phone_3: null,
                        phone_ext: formData.ext,
                        fax: formData.fax,
                        address_1: formData.address_line_1,
                        address_2: formData.address_line_2,
                        city: formData.city,
                        state: formData.state,
                        county_id: countyResult.countyId,
                        zip: formData.zip_code
                    }
                }

                let insuranceadjuster;
                if (edit) { //edit api
                    insuranceadjuster = await insuranceCarrierNurseUpdate(userToken, itemData[fieldsData.fieldId], body)
                } else { //create api
                    insuranceadjuster = await insuranceCarrierNursenCreate(userToken, body)
                }


                if (insuranceadjuster?.errorMessage) {
                    dispatch(notificationActions.setError(insuranceadjuster))     
                } else {            
                    // close modal:
                    closeModal()

                    const body = {
                        folder: folder,
                        item: {
                            itemId: itemData.id,
                            fields: [
                                {
                                    field: fieldsData.fieldId,   //'adjuster_id',
                                    value: insuranceadjuster?.id
                                },
                                {
                                    field: fieldsData.fieldobj, //'adjuster',
                                    value: insuranceadjuster
                                }
                            ]              
                        },
                    }

                    
                    dispatch(caseActions.modifyActiveCaseMultiple(body))

                    //need to re make the all reps array
                    let repsFromInsurance =  await selectInsurance(userToken, itemData.insurance_carrier_id)
                    dispatch(caseActions.setAllRepsOnItem({
                        item_id: itemData.id,
                        folder: folder,
                        content: repsFromInsurance
                    }))

                    // if it is not on edit modes, need to bind the created entity to the law firm
                    if (!edit) {
                        let reqBody = {
                            type: apiCase,
                            type_id: itemData.id,
                            fields: {
                                [fieldsData.fieldId] : insuranceadjuster?.id,
                            }
                        }
                        const update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)
                        if (update?.errorMessage) {
                            dispatch(notificationActions.setError(update))     
                        } else {
                            dispatch(notificationActions.setError({errorMessage: 'Binded to law firm', type:'success'}))
                            
                        }
                    }
                }
            } else {
                dispatch(notificationActions.setError({errorMessage : errors}))
            }
        } finally {
            setIsLoading(false)
        }
    }
    

    return <form onSubmit={formSubmitHandler}>
        {countyMismatchModal}
        <PannelBody padding='large' background={'var(--line-transparent)'}>               
            <div className={classes.subtitle}>
                Assigned Insurance
            </div>
            {itemData.insurance_carrier.name}
        </PannelBody>
        <PannelBody padding='large'>
            <div className={classes.name_container}>
                <InputBox label="First name" type="text" name="adjuster_first_name" required={true} placeholder="" currentValue={edit ? itemData[fieldsData.fieldobj].first_name : null}/>
                <InputBox label="Last name" type="text" name="adjuster_last_name" required={true} placeholder="" currentValue={edit ? itemData[fieldsData.fieldobj].last_name : null}/>
            </div>
        </PannelBody>
        <ContactInformation edit={edit} itemData={itemData} informationType={fieldsData.fieldobj} requireIdentifier={'nurse'} loading={(value) => setIsLoading(value)}/>
        <PannelFooter>
            <Button type='submit' isLoading={isLoading} width={'full'} >
                Submit 
                <i className="ti ti-chevron-right"></i>
            </Button>
        </PannelFooter>
    </form>
}

export default GeneralCreateNurseForm